/**
 * Inline sample data for all 11 new experimental designs + mating analyses.
 * Each key maps to a CSV string and a descriptive banner message.
 * This avoids backend round-trips for sample data loading.
 */

export const INLINE_SAMPLES = {
  // ── Nested Design: 4 varieties, 3 plants/variety, 3 observations/plant ──
  'nested': `Treatment,Subgroup,FruitWeight
V1,P1,45.2
V1,P1,44.8
V1,P1,46.1
V1,P2,43.9
V1,P2,44.5
V1,P2,45.2
V1,P3,46.8
V1,P3,47.1
V1,P3,46.5
V2,P4,52.3
V2,P4,53.1
V2,P4,51.8
V2,P5,54.2
V2,P5,53.8
V2,P5,55.1
V2,P6,51.5
V2,P6,52.0
V2,P6,51.2
V3,P7,38.9
V3,P7,39.4
V3,P7,40.1
V3,P8,37.8
V3,P8,38.5
V3,P8,39.2
V3,P9,40.5
V3,P9,41.2
V3,P9,40.8
V4,P10,61.2
V4,P10,60.8
V4,P10,62.1
V4,P11,59.8
V4,P11,60.5
V4,P11,61.3
V4,P12,62.5
V4,P12,63.1
V4,P12,62.8`,

  // ── Line × Tester: 3 lines × 2 testers × 3 reps (Sub-Batch 3R fix —
  //    previously fell through to backend fallback; now inline so the
  //    sample button is bulletproof regardless of network state) ──
  'lxt': `Line,Tester,Rep,Yield,Height
L1,T1,1,53.3,100.9
L1,T1,2,54.4,99.6
L1,T1,3,53.9,101.5
L1,T2,1,56.7,108.5
L1,T2,2,57.3,118.7
L1,T2,3,58.7,115.8
L2,T1,1,52.9,113.8
L2,T1,2,57.3,108.8
L2,T1,3,55.6,111.0
L2,T2,1,65.1,118.8
L2,T2,2,61.9,128.4
L2,T2,3,61.8,121.5
L3,T1,1,54.1,101.0
L3,T1,2,54.3,101.2
L3,T1,3,55.3,106.0
L3,T2,1,63.4,119.1
L3,T2,2,62.0,112.8
L3,T2,3,59.8,119.3`,

  // ── Alpha Lattice: 20 genotypes, 3 reps, 5 blocks of 4 per rep ──
  'alpha-lattice': `Genotype,Rep,Block,Yield
G1,R1,B1,68.5
G2,R1,B1,72.3
G3,R1,B1,65.1
G4,R1,B1,75.8
G5,R1,B2,70.2
G6,R1,B2,69.8
G7,R1,B2,73.5
G8,R1,B2,71.2
G9,R1,B3,66.8
G10,R1,B3,74.5
G11,R1,B3,68.2
G12,R1,B3,76.3
G13,R1,B4,72.8
G14,R1,B4,67.5
G15,R1,B4,75.1
G16,R1,B4,69.4
G17,R1,B5,71.8
G18,R1,B5,70.5
G19,R1,B5,73.2
G20,R1,B5,68.9
G1,R2,B6,69.7
G2,R2,B6,71.5
G3,R2,B6,66.6
G4,R2,B6,74.7
G5,R2,B7,70.9
G6,R2,B7,69.3
G7,R2,B7,74.8
G8,R2,B7,70.3
G9,R2,B8,67.9
G10,R2,B8,73.9
G11,R2,B8,69.0
G12,R2,B8,75.0
G13,R2,B9,73.3
G14,R2,B9,68.9
G15,R2,B9,74.4
G16,R2,B9,70.3
G17,R2,B10,70.6
G18,R2,B10,71.1
G19,R2,B10,72.8
G20,R2,B10,69.9
G1,R3,B11,67.0
G2,R3,B11,73.2
G3,R3,B11,64.4
G4,R3,B11,77.6
G5,R3,B12,69.2
G6,R3,B12,71.0
G7,R3,B12,72.9
G8,R3,B12,72.7
G9,R3,B13,65.5
G10,R3,B13,75.3
G11,R3,B13,67.3
G12,R3,B13,77.4
G13,R3,B14,71.4
G14,R3,B14,68.2
G15,R3,B14,76.4
G16,R3,B14,68.6
G17,R3,B15,72.8
G18,R3,B15,69.4
G19,R3,B15,73.7
G20,R3,B15,68.6`,

  // ── NC Design I: 4 males, 3 females/male, 3 reps (Maize GrainYield) ──
  'nc1': `Male,Female,Rep,GrainYield
M1,F1,1,45.2
M1,F2,1,48.3
M1,F3,1,43.8
M2,F1,1,52.1
M2,F2,1,55.6
M2,F3,1,50.9
M3,F1,1,38.7
M3,F2,1,41.2
M3,F3,1,39.5
M4,F1,1,61.3
M4,F2,1,63.8
M4,F3,1,59.7
M1,F1,2,46.5
M1,F2,2,47.1
M1,F3,2,45.0
M2,F1,2,53.4
M2,F2,2,54.3
M2,F3,2,52.1
M3,F1,2,39.9
M3,F2,2,40.0
M3,F3,2,40.8
M4,F1,2,60.1
M4,F2,2,65.0
M4,F3,2,58.5
M1,F1,3,44.0
M1,F2,3,49.5
M1,F3,3,42.5
M2,F1,3,51.0
M2,F2,3,56.8
M2,F3,3,49.7
M3,F1,3,37.5
M3,F2,3,42.5
M3,F3,3,38.3
M4,F1,3,62.5
M4,F2,3,62.5
M4,F3,3,60.8`,

  // ── NC Design III: 8 F2 plants × 2 crosses × 2 reps ──
  'nc3': `F2_Plant,Cross_type,Rep,Yield
P1,P1_cross,1,42.5
P1,P2_cross,1,38.1
P2,P1_cross,1,48.3
P2,P2_cross,1,44.5
P3,P1_cross,1,38.2
P3,P2_cross,1,35.8
P4,P1_cross,1,55.1
P4,P2_cross,1,51.3
P5,P1_cross,1,43.8
P5,P2_cross,1,40.2
P6,P1_cross,1,51.2
P6,P2_cross,1,47.8
P7,P1_cross,1,39.5
P7,P2_cross,1,36.4
P8,P1_cross,1,47.6
P8,P2_cross,1,44.1
P1,P1_cross,2,43.5
P1,P2_cross,2,37.2
P2,P1_cross,2,47.5
P2,P2_cross,2,45.3
P3,P1_cross,2,39.0
P3,P2_cross,2,36.5
P4,P1_cross,2,54.3
P4,P2_cross,2,52.1
P5,P1_cross,2,44.5
P5,P2_cross,2,39.5
P6,P1_cross,2,50.5
P6,P2_cross,2,48.6
P7,P1_cross,2,40.3
P7,P2_cross,2,35.6
P8,P1_cross,2,48.4
P8,P2_cross,2,43.3`,

  // ── Generation Mean Analysis: Wheat P1 P2 F1 F2 B1 B2 × 3 reps ──
  'gma': `Generation,Rep,Yield
P1,1,35.2
P1,2,34.8
P1,3,35.6
P2,1,58.3
P2,2,57.9
P2,3,58.7
F1,1,52.1
F1,2,51.8
F1,3,52.4
F2,1,48.5
F2,2,47.9
F2,3,49.1
B1,1,43.8
B1,2,43.2
B1,3,44.4
B2,1,55.2
B2,2,54.8
B2,3,55.6`,

  // ── Diallel Method IV: 5 parents, F1 only, 3 reps ──
  'diallel-m4': `Parent1,Parent2,Rep,GrainYield
P1,P2,1,48.2
P1,P3,1,45.8
P1,P4,1,52.1
P1,P5,1,50.3
P2,P3,1,43.5
P2,P4,1,49.8
P2,P5,1,47.2
P3,P4,1,46.3
P3,P5,1,44.8
P4,P5,1,51.5
P1,P2,2,47.8
P1,P3,2,46.2
P1,P4,2,51.8
P1,P5,2,49.7
P2,P3,2,44.1
P2,P4,2,50.2
P2,P5,2,46.8
P3,P4,2,45.9
P3,P5,2,45.2
P4,P5,2,52.1
P1,P2,3,48.5
P1,P3,3,45.5
P1,P4,3,52.4
P1,P5,3,50.8
P2,P3,3,43.8
P2,P4,3,49.5
P2,P5,3,47.5
P3,P4,3,46.7
P3,P5,3,44.5
P4,P5,3,51.8`,

  // ── Strip Plot (from existing backend) ──
  'strip-plot': `HStrip,VStrip,Rep,Yield
I1,V1,1,42.5
I1,V1,2,43.1
I1,V2,1,45.8
I1,V2,2,46.2
I1,V3,1,48.1
I1,V3,2,47.5
I1,V4,1,44.3
I1,V4,2,45.0
I2,V1,1,50.2
I2,V1,2,51.0
I2,V2,1,55.3
I2,V2,2,54.8
I2,V3,1,58.1
I2,V3,2,57.5
I2,V4,1,52.6
I2,V4,2,53.1
I3,V1,1,38.9
I3,V1,2,39.5
I3,V2,1,41.2
I3,V2,2,40.8
I3,V3,1,43.5
I3,V3,2,44.1
I3,V4,1,39.8
I3,V4,2,40.2`,

  // ── Latin Square ──
  'latin-sq': `Row,Column,Treatment,Yield
R1,C1,T1,45.2
R1,C2,T2,52.8
R1,C3,T3,38.9
R1,C4,T4,61.3
R1,C5,T5,48.5
R2,C1,T2,51.5
R2,C2,T3,40.2
R2,C3,T4,59.8
R2,C4,T5,47.1
R2,C5,T1,44.8
R3,C1,T3,39.5
R3,C2,T4,60.1
R3,C3,T5,49.2
R3,C4,T1,46.3
R3,C5,T2,53.1
R4,C1,T4,58.7
R4,C2,T5,48.8
R4,C3,T1,43.5
R4,C4,T2,54.2
R4,C5,T3,41.0
R5,C1,T5,50.1
R5,C2,T1,47.5
R5,C3,T2,55.8
R5,C4,T3,42.3
R5,C5,T4,62.0`,

  // ── BIB Design ──
  'bib': `Block,Treatment,Yield
B1,T1,45.2
B1,T2,52.8
B1,T3,38.9
B2,T1,44.8
B2,T4,61.3
B2,T5,48.5
B3,T2,53.1
B3,T3,39.5
B3,T6,55.2
B4,T4,60.1
B4,T5,49.2
B4,T6,54.6
B5,T1,46.3
B5,T5,50.1
B5,T7,42.3
B6,T2,54.2
B6,T6,56.0
B6,T7,43.1
B7,T3,41.0
B7,T4,62.0
B7,T7,41.9`,

  // ── Strip-Split Plot ──
  'strip-split': `HStrip,VStrip,SubPlot,Rep,Yield
Till1,Irr1,V1,1,42.5
Till1,Irr1,V1,2,43.1
Till1,Irr1,V2,1,45.8
Till1,Irr1,V2,2,46.2
Till1,Irr1,V3,1,48.1
Till1,Irr1,V3,2,47.5
Till1,Irr2,V1,1,50.2
Till1,Irr2,V1,2,51.0
Till1,Irr2,V2,1,55.3
Till1,Irr2,V2,2,54.8
Till1,Irr2,V3,1,58.1
Till1,Irr2,V3,2,57.5
Till2,Irr1,V1,1,38.9
Till2,Irr1,V1,2,39.5
Till2,Irr1,V2,1,41.2
Till2,Irr1,V2,2,40.8
Till2,Irr1,V3,1,43.5
Till2,Irr1,V3,2,44.1
Till2,Irr2,V1,1,46.8
Till2,Irr2,V1,2,47.2
Till2,Irr2,V2,1,52.1
Till2,Irr2,V2,2,51.5
Till2,Irr2,V3,1,55.6
Till2,Irr2,V3,2,56.0`,

  // ── RBD Factorial I (2-factor: Variety × Nitrogen) ──
  'rbd-f1': `Variety,Nitrogen,Rep,Yield
V1,N1,1,45.2
V1,N1,2,44.8
V1,N1,3,46.1
V1,N2,1,52.3
V1,N2,2,53.1
V1,N2,3,51.8
V2,N1,1,48.5
V2,N1,2,47.9
V2,N1,3,49.2
V2,N2,1,58.1
V2,N2,2,57.6
V2,N2,3,58.9
V3,N1,1,41.2
V3,N1,2,40.8
V3,N1,3,42.1
V3,N2,1,49.8
V3,N2,2,50.2
V3,N2,3,49.5`,

  // ── RBD Factorial II (3-factor: Variety × Nitrogen × Irrigation) ──
  'rbd-f2': `Variety,Nitrogen,Irrigation,Rep,Yield
V1,N1,I1,1,42.5
V1,N1,I1,2,43.1
V1,N1,I1,3,41.8
V1,N1,I2,1,48.2
V1,N1,I2,2,47.8
V1,N1,I2,3,49.1
V1,N2,I1,1,51.3
V1,N2,I1,2,50.8
V1,N2,I1,3,52.1
V1,N2,I2,1,58.5
V1,N2,I2,2,57.9
V1,N2,I2,3,59.2
V2,N1,I1,1,45.8
V2,N1,I1,2,46.2
V2,N1,I1,3,45.5
V2,N1,I2,1,52.1
V2,N1,I2,2,51.8
V2,N1,I2,3,52.9
V2,N2,I1,1,55.2
V2,N2,I1,2,54.8
V2,N2,I1,3,56.1
V2,N2,I2,1,63.5
V2,N2,I2,2,62.9
V2,N2,I2,3,64.2`,

  // ── RBD Factorial III (4-factor: Variety × Nitrogen × Phosphorus × Irrigation) ──
  'rbd-f3': `Variety,Nitrogen,Phosphorus,Irrigation,Rep,Yield
V1,N1,P1,I1,1,38.5
V1,N1,P1,I1,2,39.2
V1,N1,P1,I2,1,44.8
V1,N1,P1,I2,2,45.2
V1,N1,P2,I1,1,42.1
V1,N1,P2,I1,2,41.8
V1,N1,P2,I2,1,48.5
V1,N1,P2,I2,2,49.1
V1,N2,P1,I1,1,48.2
V1,N2,P1,I1,2,47.8
V1,N2,P1,I2,1,55.1
V1,N2,P1,I2,2,54.8
V1,N2,P2,I1,1,52.3
V1,N2,P2,I1,2,51.9
V1,N2,P2,I2,1,59.8
V1,N2,P2,I2,2,60.2
V2,N1,P1,I1,1,42.8
V2,N1,P1,I1,2,43.2
V2,N1,P1,I2,1,49.5
V2,N1,P1,I2,2,48.9
V2,N1,P2,I1,1,46.2
V2,N1,P2,I1,2,45.8
V2,N1,P2,I2,1,53.1
V2,N1,P2,I2,2,52.8
V2,N2,P1,I1,1,53.5
V2,N2,P1,I1,2,52.9
V2,N2,P1,I2,1,61.2
V2,N2,P1,I2,2,60.8
V2,N2,P2,I1,1,57.8
V2,N2,P2,I1,2,58.2
V2,N2,P2,I2,1,65.5
V2,N2,P2,I2,2,66.1`,

  // ── Pooled ANOVA: 10 genotypes × 3 locations × 3 reps (Wheat Yield) ──
  'pooled-anova': `Genotype,Environment,Rep,Yield
G1,Delhi,1,42.3
G1,Delhi,2,43.1
G1,Delhi,3,41.8
G1,Lucknow,1,38.5
G1,Lucknow,2,39.2
G1,Lucknow,3,37.9
G1,Kanpur,1,44.7
G1,Kanpur,2,45.3
G1,Kanpur,3,43.9
G2,Delhi,1,45.2
G2,Delhi,2,46.1
G2,Delhi,3,44.8
G2,Lucknow,1,41.3
G2,Lucknow,2,42.0
G2,Lucknow,3,40.7
G2,Kanpur,1,47.8
G2,Kanpur,2,48.5
G2,Kanpur,3,47.1
G3,Delhi,1,38.9
G3,Delhi,2,39.5
G3,Delhi,3,38.2
G3,Lucknow,1,35.1
G3,Lucknow,2,35.8
G3,Lucknow,3,34.5
G3,Kanpur,1,41.2
G3,Kanpur,2,41.9
G3,Kanpur,3,40.5
G4,Delhi,1,50.2
G4,Delhi,2,51.1
G4,Delhi,3,49.5
G4,Lucknow,1,46.3
G4,Lucknow,2,47.0
G4,Lucknow,3,45.8
G4,Kanpur,1,53.5
G4,Kanpur,2,54.2
G4,Kanpur,3,52.8
G5,Delhi,1,41.7
G5,Delhi,2,42.5
G5,Delhi,3,41.0
G5,Lucknow,1,37.8
G5,Lucknow,2,38.5
G5,Lucknow,3,37.2
G5,Kanpur,1,44.0
G5,Kanpur,2,44.7
G5,Kanpur,3,43.3
G6,Delhi,1,47.3
G6,Delhi,2,48.1
G6,Delhi,3,46.9
G6,Lucknow,1,43.5
G6,Lucknow,2,44.2
G6,Lucknow,3,42.8
G6,Kanpur,1,50.0
G6,Kanpur,2,50.8
G6,Kanpur,3,49.3
G7,Delhi,1,39.5
G7,Delhi,2,40.2
G7,Delhi,3,38.9
G7,Lucknow,1,35.7
G7,Lucknow,2,36.5
G7,Lucknow,3,35.1
G7,Kanpur,1,42.1
G7,Kanpur,2,42.8
G7,Kanpur,3,41.5
G8,Delhi,1,48.9
G8,Delhi,2,49.7
G8,Delhi,3,48.3
G8,Lucknow,1,45.0
G8,Lucknow,2,45.7
G8,Lucknow,3,44.4
G8,Kanpur,1,51.5
G8,Kanpur,2,52.3
G8,Kanpur,3,50.8
G9,Delhi,1,43.1
G9,Delhi,2,43.9
G9,Delhi,3,42.5
G9,Lucknow,1,39.2
G9,Lucknow,2,39.9
G9,Lucknow,3,38.6
G9,Kanpur,1,45.6
G9,Kanpur,2,46.3
G9,Kanpur,3,44.9
G10,Delhi,1,44.8
G10,Delhi,2,45.5
G10,Delhi,3,44.2
G10,Lucknow,1,40.9
G10,Lucknow,2,41.6
G10,Lucknow,3,40.3
G10,Kanpur,1,47.3
G10,Kanpur,2,48.1
G10,Kanpur,3,46.7`,

  // ── MANOVA Enhanced: 8 treatments × 3 reps × 4 traits ──
  'manova-enhanced': `Treatment,Rep,Yield,Protein,OilContent,PlantHeight
T1,1,42.3,11.2,18.5,120
T1,2,43.1,11.5,18.8,122
T1,3,41.8,11.0,18.3,119
T2,1,48.5,10.8,19.2,125
T2,2,49.2,11.0,19.5,127
T2,3,47.9,10.6,19.0,124
T3,1,38.9,12.5,17.8,115
T3,2,39.5,12.8,18.1,117
T3,3,38.2,12.2,17.5,114
T4,1,51.2,10.5,20.1,130
T4,2,52.0,10.7,20.4,132
T4,3,50.5,10.3,19.8,129
T5,1,45.7,11.8,18.9,123
T5,2,46.3,12.0,19.2,125
T5,3,45.0,11.6,18.7,122
T6,1,40.8,13.2,17.5,118
T6,2,41.5,13.5,17.8,120
T6,3,40.2,13.0,17.2,117
T7,1,49.5,10.9,19.6,128
T7,2,50.3,11.2,19.9,130
T7,3,48.8,10.7,19.3,127
T8,1,43.6,11.4,18.4,121
T8,2,44.3,11.7,18.7,123
T8,3,42.9,11.1,18.1,120`,

  // ── Full MET: 15 genotypes × 4 locations × 2 years × 3 reps ──
  // Generated programmatically with consistent GxE; abbreviated for size.
  'full-met': `Genotype,Location,Year,Rep,Yield
G1,Delhi,2022,1,42.3
G1,Delhi,2022,2,43.1
G1,Delhi,2022,3,41.8
G1,Delhi,2023,1,43.5
G1,Delhi,2023,2,44.2
G1,Delhi,2023,3,42.9
G1,Lucknow,2022,1,38.5
G1,Lucknow,2022,2,39.2
G1,Lucknow,2022,3,37.9
G1,Lucknow,2023,1,39.7
G1,Lucknow,2023,2,40.3
G1,Lucknow,2023,3,39.0
G1,Kanpur,2022,1,44.7
G1,Kanpur,2022,2,45.3
G1,Kanpur,2022,3,43.9
G1,Kanpur,2023,1,45.9
G1,Kanpur,2023,2,46.5
G1,Kanpur,2023,3,45.1
G1,Pune,2022,1,41.2
G1,Pune,2022,2,41.9
G1,Pune,2022,3,40.8
G1,Pune,2023,1,42.5
G1,Pune,2023,2,43.1
G1,Pune,2023,3,41.9
G2,Delhi,2022,1,45.2
G2,Delhi,2022,2,46.1
G2,Delhi,2022,3,44.8
G2,Delhi,2023,1,46.4
G2,Delhi,2023,2,47.3
G2,Delhi,2023,3,46.0
G2,Lucknow,2022,1,41.3
G2,Lucknow,2022,2,42.0
G2,Lucknow,2022,3,40.7
G2,Lucknow,2023,1,42.5
G2,Lucknow,2023,2,43.2
G2,Lucknow,2023,3,41.9
G2,Kanpur,2022,1,47.8
G2,Kanpur,2022,2,48.5
G2,Kanpur,2022,3,47.1
G2,Kanpur,2023,1,49.0
G2,Kanpur,2023,2,49.7
G2,Kanpur,2023,3,48.3
G2,Pune,2022,1,44.0
G2,Pune,2022,2,44.7
G2,Pune,2022,3,43.5
G2,Pune,2023,1,45.2
G2,Pune,2023,2,45.9
G2,Pune,2023,3,44.7
G3,Delhi,2022,1,50.2
G3,Delhi,2022,2,51.1
G3,Delhi,2022,3,49.5
G3,Delhi,2023,1,51.4
G3,Delhi,2023,2,52.3
G3,Delhi,2023,3,50.7
G3,Lucknow,2022,1,46.3
G3,Lucknow,2022,2,47.0
G3,Lucknow,2022,3,45.8
G3,Lucknow,2023,1,47.5
G3,Lucknow,2023,2,48.2
G3,Lucknow,2023,3,47.0
G3,Kanpur,2022,1,53.5
G3,Kanpur,2022,2,54.2
G3,Kanpur,2022,3,52.8
G3,Kanpur,2023,1,54.7
G3,Kanpur,2023,2,55.4
G3,Kanpur,2023,3,54.0
G3,Pune,2022,1,48.7
G3,Pune,2022,2,49.4
G3,Pune,2022,3,48.1
G3,Pune,2023,1,49.9
G3,Pune,2023,2,50.6
G3,Pune,2023,3,49.3
G4,Delhi,2022,1,38.9
G4,Delhi,2022,2,39.5
G4,Delhi,2022,3,38.2
G4,Delhi,2023,1,40.1
G4,Delhi,2023,2,40.8
G4,Delhi,2023,3,39.4
G4,Lucknow,2022,1,35.1
G4,Lucknow,2022,2,35.8
G4,Lucknow,2022,3,34.5
G4,Lucknow,2023,1,36.3
G4,Lucknow,2023,2,37.0
G4,Lucknow,2023,3,35.7
G4,Kanpur,2022,1,41.2
G4,Kanpur,2022,2,41.9
G4,Kanpur,2022,3,40.5
G4,Kanpur,2023,1,42.4
G4,Kanpur,2023,2,43.1
G4,Kanpur,2023,3,41.8
G4,Pune,2022,1,37.5
G4,Pune,2022,2,38.2
G4,Pune,2022,3,36.9
G4,Pune,2023,1,38.7
G4,Pune,2023,2,39.4
G4,Pune,2023,3,38.1
G5,Delhi,2022,1,47.3
G5,Delhi,2022,2,48.1
G5,Delhi,2022,3,46.9
G5,Delhi,2023,1,48.5
G5,Delhi,2023,2,49.3
G5,Delhi,2023,3,48.1
G5,Lucknow,2022,1,43.5
G5,Lucknow,2022,2,44.2
G5,Lucknow,2022,3,42.8
G5,Lucknow,2023,1,44.7
G5,Lucknow,2023,2,45.4
G5,Lucknow,2023,3,44.0
G5,Kanpur,2022,1,50.0
G5,Kanpur,2022,2,50.8
G5,Kanpur,2022,3,49.3
G5,Kanpur,2023,1,51.2
G5,Kanpur,2023,2,52.0
G5,Kanpur,2023,3,50.5
G5,Pune,2022,1,45.8
G5,Pune,2022,2,46.5
G5,Pune,2022,3,45.2
G5,Pune,2023,1,47.0
G5,Pune,2023,2,47.7
G5,Pune,2023,3,46.4`,

  // ── Genotype × Year: 10 genotypes × 4 years × 3 reps ──
  'genotype-year': `Genotype,Year,Rep,Yield
G1,2020,1,40.2
G1,2020,2,41.0
G1,2020,3,39.8
G1,2021,1,41.5
G1,2021,2,42.3
G1,2021,3,41.0
G1,2022,1,42.8
G1,2022,2,43.5
G1,2022,3,42.2
G1,2023,1,44.1
G1,2023,2,44.8
G1,2023,3,43.5
G2,2020,1,43.5
G2,2020,2,44.3
G2,2020,3,42.9
G2,2021,1,44.8
G2,2021,2,45.5
G2,2021,3,44.1
G2,2022,1,46.1
G2,2022,2,46.8
G2,2022,3,45.4
G2,2023,1,47.4
G2,2023,2,48.1
G2,2023,3,46.7
G3,2020,1,38.5
G3,2020,2,39.2
G3,2020,3,37.9
G3,2021,1,38.9
G3,2021,2,39.5
G3,2021,3,38.3
G3,2022,1,39.2
G3,2022,2,39.8
G3,2022,3,38.6
G3,2023,1,39.5
G3,2023,2,40.1
G3,2023,3,38.9
G4,2020,1,48.1
G4,2020,2,48.9
G4,2020,3,47.5
G4,2021,1,49.8
G4,2021,2,50.5
G4,2021,3,49.1
G4,2022,1,51.4
G4,2022,2,52.1
G4,2022,3,50.7
G4,2023,1,53.0
G4,2023,2,53.7
G4,2023,3,52.3
G5,2020,1,41.7
G5,2020,2,42.5
G5,2020,3,41.0
G5,2021,1,42.3
G5,2021,2,43.0
G5,2021,3,41.6
G5,2022,1,42.9
G5,2022,2,43.6
G5,2022,3,42.2
G5,2023,1,43.4
G5,2023,2,44.1
G5,2023,3,42.7
G6,2020,1,45.8
G6,2020,2,46.5
G6,2020,3,45.2
G6,2021,1,46.9
G6,2021,2,47.6
G6,2021,3,46.3
G6,2022,1,48.0
G6,2022,2,48.7
G6,2022,3,47.3
G6,2023,1,49.1
G6,2023,2,49.8
G6,2023,3,48.4
G7,2020,1,37.5
G7,2020,2,38.2
G7,2020,3,36.9
G7,2021,1,38.8
G7,2021,2,39.5
G7,2021,3,38.2
G7,2022,1,40.2
G7,2022,2,40.9
G7,2022,3,39.6
G7,2023,1,41.5
G7,2023,2,42.2
G7,2023,3,40.9
G8,2020,1,46.9
G8,2020,2,47.6
G8,2020,3,46.3
G8,2021,1,47.5
G8,2021,2,48.2
G8,2021,3,46.8
G8,2022,1,48.1
G8,2022,2,48.8
G8,2022,3,47.4
G8,2023,1,48.7
G8,2023,2,49.4
G8,2023,3,48.0
G9,2020,1,43.1
G9,2020,2,43.9
G9,2020,3,42.5
G9,2021,1,43.9
G9,2021,2,44.6
G9,2021,3,43.2
G9,2022,1,44.7
G9,2022,2,45.4
G9,2022,3,44.0
G9,2023,1,45.5
G9,2023,2,46.2
G9,2023,3,44.8
G10,2020,1,44.8
G10,2020,2,45.5
G10,2020,3,44.2
G10,2021,1,45.5
G10,2021,2,46.2
G10,2021,3,44.9
G10,2022,1,46.2
G10,2022,2,46.9
G10,2022,3,45.5
G10,2023,1,46.9
G10,2023,2,47.6
G10,2023,3,46.2`,
};

export const SAMPLE_BANNERS = {
  'nested': 'Sample loaded — 4 varieties, 3 plants/variety, 3 observations each (FruitWeight) — Run Analysis!',
  'alpha-lattice': 'Sample loaded — 20 genotypes, 3 reps, 5 incomplete blocks/rep (Yield) — Run Analysis!',
  'nc1': 'Sample loaded — 4 males, 3 females/male, 3 reps (Maize GrainYield) — Run Analysis!',
  'nc3': 'Sample loaded — 8 F2 plants, 2 cross types, 2 reps (Yield) — Run Analysis!',
  'gma': 'Sample loaded — P1 P2 F1 F2 B1 B2 generations, 3 reps (Wheat Yield) — Run Analysis!',
  'diallel-m4': 'Sample loaded — 5 parents, 10 F1 crosses, 3 reps (Method IV GrainYield) — Run Analysis!',
  'strip-plot': 'Sample loaded — 3 H-strips, 4 V-strips, 2 reps (Yield) — Run Analysis!',
  'latin-sq': 'Sample loaded — 5x5 Latin Square, 5 treatments (Yield) — Run Analysis!',
  'bib': 'Sample loaded — 7 treatments, 7 blocks, k=3 (Yield) — Run Analysis!',
  'strip-split': 'Sample loaded — 2 H-strips, 2 V-strips, 3 subplots, 2 reps (Yield) — Run Analysis!',
  'rbd-f1': 'Sample loaded — 3 Varieties x 2 Nitrogen doses, 3 reps (Wheat Yield) — Run Analysis!',
  'rbd-f2': 'Sample loaded — 2 Varieties x 2 Nitrogen x 2 Irrigation, 3 reps (Wheat Yield) — Run Analysis!',
  'rbd-f3': 'Sample loaded — 2 Varieties x 2 Nitrogen x 2 Phosphorus x 2 Irrigation, 2 reps (Wheat Yield) — Run Analysis!',
  'pooled-anova': 'Sample loaded — 10 genotypes × 3 locations × 3 reps (Wheat Yield) — Run Analysis!',
  'manova-enhanced': 'Sample loaded — 8 treatments × 3 reps × 4 traits (Yield, Protein, Oil, Height) — Run Analysis!',
  'lxt': 'Sample loaded — 3 lines × 2 testers × 3 reps (Yield, Height) — Run Analysis!',
  'full-met': 'Sample loaded — 5 genotypes × 4 locations × 2 years × 3 reps (Yield) — Run Analysis!',
  'genotype-year': 'Sample loaded — 10 genotypes × 4 years × 3 reps (Wheat Yield) — Run Analysis!',
};
